/**
 * @memberOf app
 * @ngdoc module
 * @description This module is used for accepting the government disclaimer that is required.
 * @name app.accept
 */

import routing from './accept.route';
import AcceptController from './accept.controller';
import AuthService from '../services/auth.service';

export default angular.module('app.accept', [AuthService])
  .config(routing)
  .controller('AcceptController', AcceptController)
  .name;


// WEBPACK FOOTER //
// ./src/client/app/accept/accept.module.js